"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PendingAttestationTypeEnum = exports.PendingAttestationToJSON = exports.PendingAttestationFromJSONTyped = exports.PendingAttestationFromJSON = void 0;
var runtime_1 = require("../runtime");
function PendingAttestationFromJSON(json) {
    return PendingAttestationFromJSONTyped(json, false);
}
exports.PendingAttestationFromJSON = PendingAttestationFromJSON;
function PendingAttestationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        '_id': !(0, runtime_1.exists)(json, '_id') ? undefined : json['_id'],
        'userId': !(0, runtime_1.exists)(json, 'userId') ? undefined : json['userId'],
        'userEmail': !(0, runtime_1.exists)(json, 'userEmail') ? undefined : json['userEmail'],
        'firstName': !(0, runtime_1.exists)(json, 'firstName') ? undefined : json['firstName'],
        'lastName': !(0, runtime_1.exists)(json, 'lastName') ? undefined : json['lastName'],
        'nickname': !(0, runtime_1.exists)(json, 'nickname') ? undefined : json['nickname'],
        'type': !(0, runtime_1.exists)(json, 'type') ? undefined : json['type'],
        'amount': !(0, runtime_1.exists)(json, 'amount') ? undefined : json['amount'],
        'creditedUsd': !(0, runtime_1.exists)(json, 'creditedUsd') ? undefined : json['creditedUsd'],
        'appliedRate': !(0, runtime_1.exists)(json, 'appliedRate') ? undefined : json['appliedRate'],
        'submittedAt': !(0, runtime_1.exists)(json, 'submittedAt') ? undefined : (new Date(json['submittedAt'])),
        'walletAddress': !(0, runtime_1.exists)(json, 'walletAddress') ? undefined : json['walletAddress'],
        'chainName': !(0, runtime_1.exists)(json, 'chainName') ? undefined : json['chainName'],
        'tokenIds': !(0, runtime_1.exists)(json, 'tokenIds') ? undefined : json['tokenIds'],
        'userNotes': !(0, runtime_1.exists)(json, 'userNotes') ? undefined : json['userNotes'],
    };
}
exports.PendingAttestationFromJSONTyped = PendingAttestationFromJSONTyped;
function PendingAttestationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        '_id': value._id,
        'userId': value.userId,
        'userEmail': value.userEmail,
        'firstName': value.firstName,
        'lastName': value.lastName,
        'nickname': value.nickname,
        'type': value.type,
        'amount': value.amount,
        'creditedUsd': value.creditedUsd,
        'appliedRate': value.appliedRate,
        'submittedAt': value.submittedAt === undefined ? undefined : (value.submittedAt.toISOString()),
        'walletAddress': value.walletAddress,
        'chainName': value.chainName,
        'tokenIds': value.tokenIds,
        'userNotes': value.userNotes,
    };
}
exports.PendingAttestationToJSON = PendingAttestationToJSON;
/**
* @export
* @enum {string}
*/
var PendingAttestationTypeEnum;
(function (PendingAttestationTypeEnum) {
    PendingAttestationTypeEnum["FUELONCHAIN"] = "FUEL_ON_CHAIN";
    PendingAttestationTypeEnum["INDUSTRYPASS"] = "INDUSTRY_PASS";
})(PendingAttestationTypeEnum = exports.PendingAttestationTypeEnum || (exports.PendingAttestationTypeEnum = {}));
